
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("ikoZN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4c08cbcf9dcf3e2f$export$2e2bcd8739ae039);

var $c3WQb = parcelRequire("c3WQb");

var $lv9xW = parcelRequire("lv9xW");

var $cSD7y = parcelRequire("cSD7y");

var $4Te8c = parcelRequire("4Te8c");
const $4c08cbcf9dcf3e2f$var$PlanResourcesInvalidateOld = ()=>{
    (0, $4Te8c.useResourceInvalidateOld)((0, $c3WQb.advancedRoadmapsReduxStoreStateResource));
    (0, $4Te8c.useResourceInvalidateOld)((0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource));
    (0, $4Te8c.useResourceInvalidateOld)((0, $c3WQb.advancedRoadmapsPlanReportPageInitialChecksResource));
    (0, $4Te8c.useResourceInvalidateOld)((0, $lv9xW.advancedRoadmapsSummaryDataResource));
    (0, $4Te8c.useResourceInvalidateOld)((0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource));
    return null;
};
/**
 * Cleanups the cache when the resource key change or unmount.
 * This way of invalidation is not available yet on the react-resource-router
 */ const $4c08cbcf9dcf3e2f$var$PlanResourcesInvalidateNew = ()=>{
    (0, $4Te8c.useResourceInvalidate)((0, $c3WQb.advancedRoadmapsReduxStoreStateResource));
    (0, $4Te8c.useResourceInvalidate)((0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource));
    (0, $4Te8c.useResourceInvalidate)((0, $c3WQb.advancedRoadmapsPlanReportPageInitialChecksResource));
    (0, $4Te8c.useResourceInvalidate)((0, $lv9xW.advancedRoadmapsSummaryDataResource));
    (0, $4Te8c.useResourceInvalidate)((0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource));
    return null;
};
const $4c08cbcf9dcf3e2f$var$PlanResourcesInvalidate = (0, $cSD7y.componentWithFG)('fix_plan_app_refresh', $4c08cbcf9dcf3e2f$var$PlanResourcesInvalidateNew, $4c08cbcf9dcf3e2f$var$PlanResourcesInvalidateOld);
var $4c08cbcf9dcf3e2f$export$2e2bcd8739ae039 = $4c08cbcf9dcf3e2f$var$PlanResourcesInvalidate;

});
parcelRegister("4Te8c", function(module, exports) {

$parcel$export(module.exports, "useResourceInvalidateOld", () => $b78a1b8a11e72a7e$export$8a37267fcb8220e6);
$parcel$export(module.exports, "useResourceInvalidate", () => $b78a1b8a11e72a7e$export$b53e28d71b4855d0);

var $5uXOq = parcelRequire("5uXOq");

var $2YP9W = parcelRequire("2YP9W");

var $1XJ20 = parcelRequire("1XJ20");
const $b78a1b8a11e72a7e$export$8a37267fcb8220e6 = (resource)=>{
    const { clear: clear, key: key } = (0, $2YP9W.useResource)(resource);
    (0, $5uXOq.useEffect)(()=>()=>{
            clear();
        }, [
        key,
        clear
    ]);
};
const $b78a1b8a11e72a7e$export$b53e28d71b4855d0 = (resource)=>{
    const { clear: clear, key: key = '' } = (0, $2YP9W.useResource)(resource);
    const previousKey = (0, $1XJ20.usePrevious)(key);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            /**
			 * "previousKey" plays an important role for keeping track of cleanup.
			 * Adding this dependency close the gap in the effect discrepancy between strict and non strict mode.
			 *
			 * NON STRICT MODE:
			 * During the initial load: no cleanup effect.
			 *
			 * STRICT MODE:
			 * During initial load: cleanup effect is called multiple times. Resource clearing is prevented due to the previousKey being undefined.
			 *
			 * Both modes:
			 * Transition to other plan: cleanup effect may be called multiple times; Only clearing resource when it has the old key.
			 * Transition to non plan: cleanup effect is called once; clearing the plan resource.
			 * Transition to pages in the same plan: no cleanup effect.
			 */ if (previousKey && key === previousKey) clear();
        };
    }, [
        key,
        clear,
        previousKey
    ]);
};

});



//# sourceMappingURL=async-plan-resources-invalidate.8c67b088.js.map
